import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import { AUTH_REDIRECT } from 'pobble-components/dist/cookies'
import { URLS } from 'pobble-components/dist/setup'
import Buttonelement from 'pobble-components/dist/button-element'
import { useParams } from 'react-router-dom'
import classNames from 'classnames'
import posthog from 'posthog-js'

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    transition: 'opacity 0.3s ease-out',
    zIndex: 999
  },
  popupDialog: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    borderRadius: '8px',
    padding: '56px',
    zIndex: 1000,
    transition: 'opacity 0.5s ease-out',
    textAlign: 'center',
    maxWidth: '500px',
    width: 'calc(100vw - 24px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    font: 'var(--body)',
    '& > *': {
      margin: '0'
    }
  },
  button: {
    marginTop: '16px'
  },
  login: {
    display: 'flex',
    flexDirection: 'column',
    font: 'var(--body-)',
    alignItems: 'center',
    '& button': {
      color: 'var(--gray-)',
      textDecoration: 'underline',
      '&:hover, &:focus': {
        textDecoration: 'none'
      }
    }
  },
  legals: {
    fontSize: '12px',
    position: 'relative',
    top: '20px',
    color: '#707070',
    '& a': {
      textDecoration: 'none',
      color: '#707070'
    }
  }
}

const PopupDialog = ({ classes }) => {
  const [opacity, setOpacity] = useState(0)

  const { id } = useParams()

  const checkScrollPosition = () => {
    let maxScroll = document.body.scrollHeight - window.innerHeight
    let currentScroll = window.pageYOffset
    let percentageScrolled = currentScroll / maxScroll
    setOpacity(percentageScrolled > 1 / 3 ? 1 : 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', checkScrollPosition)
    return () => window.removeEventListener('scroll', checkScrollPosition)
  }, [])

  /**
   * Sets the signup redirect cookie to the copy route for a current lesson id
   *
   * The copy route copies this lesson and redirects the user
   *   to a builder with the copied lesson
   *
   */
  const setSignupRedirect = () =>
    AUTH_REDIRECT.set(`${URLS.APP}/lessons/copy/${id}`)

  return (
    <>
      <div className={classes.overlay} style={{ opacity: opacity }} />
      <div className={classes.popupDialog} style={{ opacity: opacity }}>
        <h2>Want one like this every day? 🤩</h2>
        <p>
          Create your free Pobble account to use today’s prompt, plus a new free
          one daily. 🙌
        </p>
        <p>No planning. No setup. No payment details.</p>
        <Button
          onClick={() => {
            posthog.capture('clicked on teacher preview cta', {
              url: window.location.href
            })
            setSignupRedirect()
            window.location.href = '/auth/sign-up?from=teacher-preview'
          }}
          className={classNames(classes.button, 'metrics__teacher-preview-cta')}
          tall
          darkBlue>
          Get Pobble for free
        </Button>
        <div className={classes.login}>
          <span>Already on board?</span>
          <Buttonelement
            className="metrics__teacher-preview-sign_in"
            onClick={() => {
              posthog.capture('clicked on teacher preview cta', {
                url: window.location.href
              })
              setSignupRedirect()
              window.location.href = '/auth?from=teacher-preview'
            }}
            href="/auth">
            Sign in
          </Buttonelement>
        </div>
        <div className={classes.legals}>
          <a
            href="https://www.pobble.com/terms-of-service"
            rel="noopener noreferrer"
            target="_blank">
            Terms of service
          </a>{' '}
          &bull;{' '}
          <a
            href="https://www.pobble.com/privacy-policy"
            rel="noopener noreferrer"
            target="_blank">
            Privacy policy
          </a>
        </div>
      </div>
    </>
  )
}

export default injectSheet(styles)(PopupDialog)
